'use client';

export function currentRelativeUrl() {
  if (typeof window === 'undefined') return '/';
  const current = new URL(window.location.href);
  return `${current.pathname}${current.search}${current.hash}` || '/';
}

export function sanitizeRedirect(input?: string | null) {
  if (!input) return '/';

  if (input.startsWith('//')) {
    return '/';
  }

  if (input.startsWith('/')) {
    return input;
  }

  try {
    const url = new URL(input);
    const relative = `${url.pathname}${url.search}${url.hash}`;
    return relative.startsWith('/') ? relative : '/';
  } catch {
    return '/';
  }
}

export function buildSignInRedirect(redirect?: string | null) {
  const safe = sanitizeRedirect(redirect);
  return `/sign-in?redirect=${encodeURIComponent(safe)}`;
}
